<!-- 全局变量 -->
<script>
    // const kefu_url = 'localhost:8081'; //本地网站地址
    const kefu_url = 'v2fwfafhpp.m9skins.com'; //客服网站地址
    let host_url=window.location.host;
    let kefu_flag= host_url!=kefu_url;//判断是否是客服后台 true不显示 false显示
    export default {
      kefu_flag
    }
</script>